export const routesYapilacaklar = [
  {
    path: "/yapilacaklar",
    name: "yapilacaklar",
    component: () => import("@/views/yapilacaklar/index.vue"),
    meta: {
      public: false,
      title: "Yapılacaklar",
      yetki: { k: [] },
    },
  },
]
